import brand from "./brand";
import category from "./category";
import gender from "./gender";
import limit from "./limit";
import offset from "./offset";
import type from "./type";
import tableId from "./tableId";
import acceptsLanguages from "./acceptsLanguages";
import userEmailFilter from "./userEmailFilter";
import userEmailIdentifier from "./userEmailIdentifier";
import measureId from "./measureId";
import cwid from "./cwid";
import contentType from "./contentType";
import userNameFilter from "./userNameFilter";
import friendId from "./friendId";

export default {
  brand,
  category,
  gender,
  limit,
  offset,
  type,
  tableId,
  acceptsLanguages,
  userEmailFilter,
  userEmailIdentifier,
  measureId,
  cwid,
  contentType,
  userNameFilter,
  friendId
};
